import { render, staticRenderFns } from "./play-pause-control.vue?vue&type=template&id=4dab5453&"
import script from "./play-pause-control.vue?vue&type=script&lang=js&"
export * from "./play-pause-control.vue?vue&type=script&lang=js&"
import style0 from "./play-pause-control.vue?vue&type=style&index=0&lang=less&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports